// Shared, reused strings (buttons, generic words).
const common = {
  en: {
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.saving': 'Saving…',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.add': 'Add',
    'common.close': 'Close',
    'common.remove': 'Remove',
    'common.confirm': 'Confirm',
    'common.back': 'Back',
    'common.loading': 'Loading…',
    'common.or': 'or',
    'common.search': 'Search…',
    'common.retry': 'Try again',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.offline': 'You are offline. Some changes may not be saved.',
    'common.updateAvailable': 'A new version is available.',
    'common.reload': 'Reload',
    'common.dismiss': 'Dismiss',
    'common.refresh': 'Refresh',
    'common.later': 'Later',
    'common.offlineFeatures': 'You\'re offline — changes will sync when you reconnect',
    'common.somethingWentWrong': 'Something went wrong',
    'common.unexpectedError': 'An unexpected error occurred. Please try again.',
    'common.tryAgain': 'Try Again',
    'common.reloadPage': 'Reload Page',
    'common.errorFirebaseSync': 'Unable to sync with cloud storage. Please check your internet connection.',
    'common.errorNetwork': 'Network connection error. Please check your internet connection and try again.',
    'common.component': 'Component',
    'common.componentUnavailable': '{name} temporarily unavailable',
    'common.errorDetailsDev': 'Error Details (Development Only)',
    'common.connectionIssue': 'Connection Issue',
    'common.appContextError': 'App Context Error',
    'common.contextErrorIntro': 'There was an error with the application state. This might be due to:',
    'common.contextErrorReasonSync': 'Data synchronization issues',
    'common.contextErrorReasonFormat': 'Invalid data format',
    'common.contextErrorReasonProvider': 'Context provider errors',
    'common.restartApp': 'Restart App',
    'common.resetAppData': 'Reset App Data',
    'common.selectTodo': 'Select a to-do',
    'common.clearTodo': 'Clear to-do',
    'common.noSavedTodos': 'No saved to-dos. Add some in Manage to-do.',
    'common.loadingCalendarDay': 'Loading calendar day...',
    'common.loadingItems': 'Loading {count} items...',
    'common.loadingListItems': 'Loading list items...',
  },
  lt: {
    'common.cancel': 'Atšaukti',
    'common.save': 'Išsaugoti',
    'common.saving': 'Išsaugoma…',
    'common.delete': 'Ištrinti',
    'common.edit': 'Redaguoti',
    'common.add': 'Pridėti',
    'common.close': 'Uždaryti',
    'common.remove': 'Pašalinti',
    'common.confirm': 'Patvirtinti',
    'common.back': 'Atgal',
    'common.loading': 'Kraunama…',
    'common.or': 'arba',
    'common.search': 'Ieškoti…',
    'common.retry': 'Bandyti dar kartą',
    'common.yes': 'Taip',
    'common.no': 'Ne',
    'common.offline': 'Esate neprisijungę. Kai kurie pakeitimai gali būti neišsaugoti.',
    'common.updateAvailable': 'Yra nauja versija.',
    'common.reload': 'Perkrauti',
    'common.dismiss': 'Uždaryti',
    'common.refresh': 'Atnaujinti',
    'common.later': 'Vėliau',
    'common.offlineFeatures': 'Esate neprisijungę — pakeitimai bus sinchronizuoti, kai vėl prisijungsite',
    'common.somethingWentWrong': 'Kažkas nutiko',
    'common.unexpectedError': 'Įvyko netikėta klaida. Bandykite dar kartą.',
    'common.tryAgain': 'Bandyti dar kartą',
    'common.reloadPage': 'Perkrauti puslapį',
    'common.errorFirebaseSync': 'Nepavyko sinchronizuoti su debesų saugykla. Patikrinkite interneto ryšį.',
    'common.errorNetwork': 'Tinklo ryšio klaida. Patikrinkite interneto ryšį ir bandykite dar kartą.',
    'common.component': 'Komponentas',
    'common.componentUnavailable': '{name} laikinai neprieinamas',
    'common.errorDetailsDev': 'Klaidos informacija (tik kūrimo režimu)',
    'common.connectionIssue': 'Ryšio problema',
    'common.appContextError': 'Programos konteksto klaida',
    'common.contextErrorIntro': 'Įvyko programos būsenos klaida. Tai galėjo nutikti dėl:',
    'common.contextErrorReasonSync': 'Duomenų sinchronizavimo problemų',
    'common.contextErrorReasonFormat': 'Netinkamo duomenų formato',
    'common.contextErrorReasonProvider': 'Konteksto tiekėjo klaidų',
    'common.restartApp': 'Paleisti iš naujo',
    'common.resetAppData': 'Atstatyti programos duomenis',
    'common.selectTodo': 'Pasirinkite užduotį',
    'common.clearTodo': 'Išvalyti užduotį',
    'common.noSavedTodos': 'Nėra išsaugotų užduočių. Pridėkite jų skiltyje „Tvarkyti užduotis“.',
    'common.loadingCalendarDay': 'Kraunama kalendoriaus diena…',
    'common.loadingItems': 'Kraunama {count} elementų…',
    'common.loadingListItems': 'Kraunami sąrašo elementai…',
  },
};

export default common;
